import { Helmet } from '@dr.pogodin/react-helmet';
import { Link } from 'react-router';
import HashLink from '../common/lib/HashLink';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/pubmedpdf.css';
import PubmedPdfUtils from './lib/PubmedPdfUtils';

interface Props {
    lang: MultiLang;
}

const PubmedPdfIndex = (props: Props) => {
    const { lang } = props;
    const name = PubmedPdfUtils.getName();
    const mtitle = Functions.mlang(name, lang);
    const authorInitials = PubmedPdfUtils.getAuthorInitials();
    const years = PubmedPdfUtils.getYears();
    const journalInitials = PubmedPdfUtils.getJournalInitials();
    return (
        <div className="pubmedpdf">
            <Helmet>
                <title>
                    {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{mtitle}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <nav className="header">
                <div className="count">
                    <strong>{PubmedPdfUtils.getCountPapers()}</strong> papers registered
                </div>
                <div className="link">
                    <a href="https://www.ncbi.nlm.nih.gov/pubmed" target="_blank" rel="noopener noreferrer">
                        [PubMed]
                    </a>
                </div>
            </nav>
            <h4 className="pt">{Functions.mlang('[en]Author[/en][ja]著者[/ja]', lang)}</h4>
            <div className="initials">
                {authorInitials.map((initial) => {
                    return (
                        <span className="initial" key={initial}>
                            <Link to={PubmedPdfUtils.getAuthorInitialUrl(initial)}>{initial}</Link>
                        </span>
                    );
                })}
            </div>
            <h4 className="pt">{Functions.mlang('[en]Year[/en][ja]発行年[/ja]', lang)}</h4>
            <div className="years">
                {years.map((year) => {
                    return (
                        <div className="year" key={year.year}>
                            <Link to={PubmedPdfUtils.getYearUrl(year.year, 0)}>{year.year}</Link> ({year.count})
                        </div>
                    );
                })}
            </div>
            <h4 className="pt">{Functions.mlang('[en]Journal/Book[/en][ja]ジャーナル／書籍[/ja]', lang)}</h4>
            <div className="journals">
                {journalInitials.map((initial) => {
                    return (
                        <span className="initial" key={initial}>
                            <HashLink to={`${PubmedPdfUtils.getIndexUrl()}#${initial}`}>{initial}</HashLink>
                        </span>
                    );
                })}
                {journalInitials.map((initial) => {
                    const journals = PubmedPdfUtils.getJournalsByInitial(initial);
                    return (
                        <div id={initial} className="journal-group" key={initial}>
                            <div className="title">{initial}</div>
                            {journals.map((journal) => {
                                const name = Functions.mlang(journal.name, lang);
                                const nameShort = name.slice(0, 20) + (name.length > 20 ? '...' : '');
                                return (
                                    <div className="journal" key={journal.id}>
                                        <Link to={PubmedPdfUtils.getJournalUrl(journal.id, 0)} title={name}>
                                            {nameShort}
                                        </Link>{' '}
                                        ({journal.count})
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PubmedPdfIndex;
